import { createContext, useContext, useMemo } from "react";
import type { ReactNode } from "react";
import { useViewer } from "../../state/ViewerProvider";
import { capsFor, type Caps } from "./caps";

const CapsContext = createContext<Caps | null>(null);

/** Provides session-static capability gates derived from the viewer contract. */
export function CapsProvider({ children }: { children: ReactNode }) {
  const { client } = useViewer();
  const caps = useMemo(() => capsFor(client.contractVersion), [client.contractVersion]);
  return <CapsContext.Provider value={caps}>{children}</CapsContext.Provider>;
}

export function useCaps(): Caps {
  const c = useContext(CapsContext);
  if (!c) throw new Error("useCaps must be used within a CapsProvider");
  return c;
}
